<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span @click="resetSingleSidebarFilter(name)" title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        :id="`popover-create`"
        class="btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea un nuovo acconto"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
      <b-button
        size="sm"
        type="button"
        class="btn--smaller btn--transparent"
        variant="secondary"
        title="Chiusura Massiva"
        :disabled="!this.checkedRows || !this.isDeferred"
        @click="openMassReducedModal"
        ><b-icon icon="plus-circle" aria-hidden="true"></b-icon>
        Chiusura Massiva
      </b-button>
      <export-options
        :exportUrl="exportUrl"
        :repository="repository"
        :resource="resource"
        :tableRef="$refs[tableRef]"
        :filter="filter"
        :options="[
          {
            code: 'EXCOGIAC',
            label: null,
            formats: ['csv', 'pdf'],
          },
        ]"
      ></export-options>
    </actions-toolbar>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      shadow
      right
      :visible="open_filter"
      :data-open="open_filter"
      @change="onSidebarFilterChange"
    >
      <template #header="{ hide }">
        <div class="inner-header">
          <template v-if="canVerb(resource, 'store')">
            <div class="inner-header--create">
              <strong class="mr-auto"> Crea un nuovo acconto </strong>
              <b-button
                class="btn btn--create btn--smaller"
                type="button"
                variant="primary"
                size="sm"
                @click="onAdd"
                title="Crea un nuovo sospeso"
                :disabled="!canVerb(resource, 'store')"
              >
                <base-icon name="circled_plus" width="16" height="16" />
                <span>Crea</span>
              </b-button>
            </div>
            <div class="inner-header--info">
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </div>
          </template>
          <template v-else>
            <strong class="mr-auto">
              {{ computedFilterTitle }}
            </strong>
            <button class="close text-dark" @click="hide">
              <b-icon icon="x"></b-icon>
            </button>
          </template>
        </div>
      </template>
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item">
            <base-select
              name="salesmen"
              label="Produttore"
              :options="salesmen_select"
              v-model="filter.produttore"
              :multiple="true"
              :taggable="salesmen_taggable"
              :closeOnSelect="false"
              :defaultHtmlMultipleSelect="true"
              @changeTaggable="changeTaggable"
            >
              <template #advanced-actions>
                <b-button
                  :pressed.sync="myToggle"
                  variant="light"
                  class="btn--x-smaller btn--smaller btn--transparent"
                  @click="myToggle ? selectAllSalesmen() : deselectAllSalesmen()"
                  >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                </b-button>
                <b-button
                  :pressed.sync="myTogglePO"
                  variant="light"
                  class="btn--smaller btn--x-smaller btn--transparent"
                  @click="
                    myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                  "
                  >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                </b-button>
              </template>
            </base-select>
          </div>
          <div class="filter-item">
            <base-select
              name="deposit"
              label="Tipologia"
              :options="deposit"
              v-model="filter.stato"
              @select="onSelectDepositedType"
            />
          </div>
          <div class="filter-item">
            <base-input
              name="title"
              type="text"
              label="Descrizione"
              v-model="filter.descrizione"
              placeholder="Inserisci una descrizione"
            />
          </div>
          <div class="filter-item" data-cols="2">
            <base-datepicker
              name="created_at"
              label="Data Apertura dal"
              v-model="filter.data_registrazione_inizio"
              :readonly="lockedDates"
              :disabled="lockedDates"
            />
            <base-datepicker
              name="created_at"
              label="Data Apertura al"
              v-model="filter.data_registrazione_fine"
              :readonly="lockedDates"
              :disabled="lockedDates"
            />
          </div>
          <div class="filter-item" data-cols="2">
            <base-datepicker
              name="cash_time"
              label="Data Recupero dal"
              v-model="filter.data_recupero_inizio"
              :readonly="lockedDates"
              :disabled="lockedDates"
            />
            <base-datepicker
              name="cash_time"
              label="Data Recupero al"
              v-model="filter.data_recupero_fine"
              :readonly="lockedDates"
              :disabled="lockedDates"
            />
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>

    <deposited-entry-details-table
      @edit="onEdit"
      @manualFetch="manualFetch"
      :fields="fields"
      :repository="repository"
      :resource="resource"
      :performedSearch="computePerformedSearch"
      :filterCount="countActiveFilters"
      :filterName="filterName"
      :filterOn="{
        tipo: 'acconto',
        byRelations: ['byBroker', 'byTreasury', 'byCashReference'],
      }"
      @destroy="onDestroy"
      :ref="tableRef"
      :onlyActions="['edit', 'destroy', 'infomodal']"
    ></deposited-entry-details-table>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import DepositedEntryDetailsTable from "@/components/tables/DepositedEntryDetails.vue";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import { mapActions, mapGetters } from "vuex";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import ExportOptions from "@/components/ExportOptions";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";
import BaseIcon from "@/components/BaseIcon";
import moment from "moment/moment";

export default {
  mixins: [CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      repository: "cash_entry",
      resource: "movimenti_prima_nota",
      tableRef: "CashEntriesDepositedTableRef",
      filterName: "filterCashEntriesDeposited",
      grandtotaldeposited: 0,
      filter: this.initFilter(),
      lockedDates: false,
      checkedRows: false,
      isDeposited: true,
      myToggle: false,
      myTogglePO: false,
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_taggable: true,
      minMassReducedDate: "1970-01-01",
      activeCheckboxes: [],
      activeFilters: {},
      performedSearch: false,
      deposit: [
        { value: "tutti", text: "Tutti" },
        { value: "aperti", text: "Aperti" },
        { value: "aperti-parziali", text: "Aperti e parzialmente recuperati" },
        { value: "chiusi", text: "Chiusi" },
        { value: "chiusi-parziali", text: "Chiusi e parzialmente incassati" },
      ],
      fields: [
        {
          key: "recovery_status",
          label: this.getDictionary("Stato"),
          sortable: false,
        },
        {
          key: "conto.codice",
          label: this.getDictionary("Conto"),
          sortable: true,
          sortKey: "byAttribute.conto",
        },
        {
          key: "data_registrazione",
          formatter: (value) => toLocaleDate(value),
          label: this.getDictionary("cash_time", "cash_entry"),
          sortable: true,
          sortKey: "byAttribute.data_registrazione",
        },
        {
          key: "recuperi",
          formatter: (value) => this.getLastCashEntry(value),
          label: "Data ultimo recupero",
          sortable: true,
          sortKey: "byAttribute.data_recupero",
        },
        {
          key: "descrizione",
          label: this.getDictionary("description", "cash_entry"),
          sortable: true,
          sortKey: "byAttribute.descrizione",
        },
        {
          key: "causale",
          label: "Causale",
          formatter: (value) => `${value.codice} - ${value.descrizione}`,
          sortable: true,
          sortKey: "byAttribute.causale",
        },
        {
          key: "produttore.formatted_title",
          formatter: (value) => (value ? value : "-"),
          label: this.getDictionary("broker_id", "cash_entry"),
          sortable: true,
          sortKey: "byAttribute.produttore",
        },
        {
          key: "importo",
          formatter: (value) => toLocaleCurrency(Math.abs(parseFloat(value))),
          label: this.getDictionary("Importo"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          sortable: true,
          sortKey: "byAttribute.importo",
        },
        {
          key: "recupero",
          formatter: (value) => toLocaleCurrency(Math.abs(parseFloat(value))),
          label: "Incassato",
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          sortable: true,
          sortKey: "byAttribute.incassato",
        },
        {
          key: "residuo",
          formatter: (value, field, item) =>
            toLocaleCurrency(
              item.importo - (item.recupero ? item.recupero : 0),
            ),
          label: this.getDictionary("Residuo"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
        },
      ],
    };
  },
  components: {
    BaseIcon,
    DepositedEntryDetailsTable,
    BaseDatepicker,
    BaseInput,
    BaseSelect,
    ExportOptions,
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllSalesmen() {
      this.filter.produttore = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllSalesmen() {
      this.filter.produttore = [];
      this.salesman_id = null;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.checkedRows = false;
      this.activeCheckboxes = [];
      this.exportUrl = null;
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    onSelectDepositedType(selected) {
      switch (selected) {
        case "both":
          this.lockedDates = true;
          break;
        default:
          this.lockedDates = false;
          break;
      }
      this.visible = true;
    },
    getLastCashEntry(value) {
      if (!value || !value.length) return "-";
      const lastCashEntry = value.at(-1);
      if (!lastCashEntry || !lastCashEntry.data_registrazione) return "-";
      return toLocaleDate(lastCashEntry.data_registrazione);
    },
    initFilter() {
      let init = {
        stato: "aperti-parziali",
        byAttribute: {
          title: null,
          created_at: null,
          cash_time: null,
        },
        byCashReference: {
          reference_type: [1, 3],
        },
        byBroker: {
          id: null,
        },
        byDeposited: "yes",
        byCashTime: {
          to: null,
          from: null,
        },
        byCashHistory: {
          to: null,
          from: null,
        },
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id) {
      this.$router.push({
        name: `${this.resource}.edit2`,
        params: { id: `${id}` },
      });
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create2` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.cancellaAcconto(id)
        .then(() => {
          this.$refs[this.tableRef].sortBy = "data_registrazione";
          this.$refs[this.tableRef].sortAsc = true;
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Acconto eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["byCashReference.reference_type"];
      delete this.activeFilters["byDeposited"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      if (this.filter.byDeposited) {
        let criteria = this.filter;
        this.saveFilterByName({ name, criteria });
        this.exportUrl = this.$refs[this.tableRef].loadFilter(
          this.$refs[this.tableRef].filterName,
        );
        this.removePaginationByName(name);
        this.$refs[this.tableRef].currentPage = 1;
        this.isDeposited = true;
        this.$refs[this.tableRef].fetch().then(() => {
          this.isDeferred = !this.$refs[this.tableRef].items.length
            ? false
            : this.$refs[this.tableRef].items.every(
                (item) => item.gross + item.reduced != 0,
              );
          this.onInteraction;
        });
      } else {
        this.$showSnackbar({
          preset: "success",
          text: "Il campo 'Tipologia' è obbligatorio",
        });
      }
    },
    onInteraction(selectedRows, reducedDate, checked) {
      if (checked) {
        this.activeCheckboxes.push(reducedDate);
      } else {
        this.activeCheckboxes = this.activeCheckboxes.filter(
          (v) => v !== reducedDate,
        );
      }
      const arrSet = [...new Set(this.activeCheckboxes)];
      this.minMassReducedDate = arrSet.length
        ? arrSet.reduce((a, b) => (moment(a).isAfter(b) ? a : b))
        : "1970-01-01";
      this.checkedRows = selectedRows && selectedRows > 0 ? true : false;
    },
    openMassReducedModal() {
      this.grandtotaldeposited =
        this.$refs["CashEntriesDepositedTableRef"].grandTotalDeposited;
      this.$bvModal.show("massReducedModal");
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
  },
};
</script>
